function pendingTrialBreakdown(value) {
  if (!value || !['pendingPaise', 'pendingCashbackPaise', 'pendingBonusPoints'].every(key => Number.isSafeInteger(value[key]) && value[key] >= 0)) return null;
  const total = value.pendingCashbackPaise + value.pendingBonusPoints * 100;
  return Number.isSafeInteger(total) && total === value.pendingPaise ? {cashbackPaise:value.pendingCashbackPaise, bonusPoints:value.pendingBonusPoints, totalPaise:total} : null;
}

function normalizeWalletCart(cart) {
 if(!cart||cart.currency!=='INR'||!Array.isArray(cart.items)||!cart.items.length||cart.items.length>100)throw new Error('Add eligible full-size products to your INR cart first.');
 let total=0;
 const rows=cart.items.map(item=>{
  const raw=item.variant_id;
  const id=typeof raw==='number'&&Number.isSafeInteger(raw)?String(raw):raw;
  if(typeof id!=='string'||!/^[1-9]\d{0,19}$/.test(id)||!Number.isSafeInteger(item.quantity)||item.quantity<1)throw new Error('Your cart needs to be refreshed before using the wallet.');
  total+=item.quantity;
  if(total>100||item.gift_card||item.remote||item.selling_plan_allocation||(item.properties&&Object.keys(item.properties).length))throw new Error('Wallet checkout supports standard full-size products only. Remove gift cards, subscriptions or personalised items first.');
  return {variantId:`gid://shopify/ProductVariant/${id}`,quantity:item.quantity,title:typeof item.title==='string'?item.title.slice(0,240):'Full-size product'};
 });
 return {lines:rows.map(({variantId,quantity})=>({variantId,quantity})),rows};
}
function verifiedInvoiceUrl(value,shop='faimly-farm.myshopify.com') {
 if(typeof value!=='string'||value.length>4096||/[\u0000-\u0020\u007f]/.test(value))return null;
 if(typeof shop!=='string'||!/^[a-z0-9][a-z0-9-]*\.myshopify\.com$/.test(shop))return null;
 try {const url=new URL(value);return url.protocol==='https:'&&!url.username&&!url.password&&!url.port&&url.hostname===shop&&/\/(?:invoices|invoice)\//.test(url.pathname)?url.href:null;}catch{return null;}
}

(()=>{
 if(window.ffTrialWalletLoaded)return;window.ffTrialWalletLoaded=true;
 const base='/apps/future-wallet',storageKey='faimly-wallet-checkout-v1';
 const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR'}).format(n/100);
 const panels=()=>[...document.querySelectorAll('[data-ff-wallet-panel]')];
 let signedIn=window.ffAccountSession?.isSignedIn()===true||panels().some(p=>p.dataset.ffWalletSignedIn==='true');
 let cached=null,loadedAt=0,inflight=null,busy=false,epoch=0,needsLogin=false;
 const copy=panel=>JSON.parse(panel.querySelector('[data-ff-wallet-copy]').textContent);
 const status=(panel,text)=>{const node=panel.querySelector('[data-ff-wallet-status]');if(node)node.textContent=text;};
 const walletHeaders=(url,initial)=>{
  const headers=new Headers(initial||{}),target=new URL(url,location.origin);
  headers.delete('X-OTP-NCA-Token');
  if(target.origin!==location.origin||!target.pathname.startsWith(base+'/'))return headers;
  try{
   if(!localStorage.getItem('otp_plus_logout_pending')){
    const token=localStorage.getItem('otp_plus_nca_session_token')||sessionStorage.getItem('otp_plus_nca_session_token');
    if(typeof token==='string'&&/^[\x21-\x7e]{1,8192}$/.test(token))headers.set('X-OTP-NCA-Token',token);
   }
  }catch{}
  return headers;
 };
 async function json(url,options={}){
  const r=await fetch(url,{credentials:'same-origin',cache:'no-store',redirect:'error',...options,headers:walletHeaders(url,options.headers),signal:AbortSignal.timeout(15000)});
  if(!r.ok){const error=new Error('Unable to verify');error.httpStatus=r.status;throw error;}return r.json();
 }
 function render(panel){
  const text=copy(panel),button=panel.querySelector('[data-ff-wallet-apply]');
  const allowed=signedIn&&!needsLogin;
  panel.querySelectorAll('[data-ff-wallet-content]').forEach(node=>{node.hidden=!allowed;});
  panel.querySelectorAll('[data-ff-wallet-login]').forEach(node=>{node.hidden=allowed;});
  if(button)button.disabled=true;
  const detail=panel.querySelector('[data-ff-wallet-breakdown]');if(detail)detail.hidden=true;
  if(!allowed||!cached){
   for(const key of ['available','pending','reserved']){const node=panel.querySelector('[data-ff-wallet-'+key+']');if(node)node.textContent='—';}
   status(panel,!allowed?text.signin:inflight?text.loading:text.unavailable);return;
  }
  const split=pendingTrialBreakdown(cached);
  if(detail&&split&&split.totalPaise>0){detail.hidden=false;detail.querySelector('[data-ff-wallet-cashback]').textContent=money(split.cashbackPaise);detail.querySelector('[data-ff-wallet-bonus]').textContent=text.bonus_value.replaceAll('__points__',split.bonusPoints).replace('__value__',money(split.bonusPoints*100));detail.querySelector('[data-ff-wallet-combined]').textContent=money(split.totalPaise);}
  for(const key of ['available','pending','reserved']){const node=panel.querySelector('[data-ff-wallet-'+key+']');if(node)node.textContent=money(cached[key+'Paise']);}
  const held=cached.reservedPaise>0;
  status(panel,cached.frozen||!cached.redemptionEnabled?text.paused:held?text.held_message:cached.availablePaise>0?text.ready:cached.pendingPaise>0?text.pending_message:text.none);
  if(button){button.textContent=text.apply;button.disabled=busy||held||cached.frozen||!cached.redemptionEnabled||cached.availablePaise<1;}
 }
 function invalidateWalletSession(){
  panels().forEach(panel=>{panel.dataset.ffWalletSignedIn='false';});
  window.ffAccountSession?.invalidate?.();
  epoch+=1;signedIn=false;cached=null;loadedAt=0;inflight=null;needsLogin=true;
  panels().forEach(render);
 }
 function validBalance(value){
  return value?.currency==='INR'&&['availablePaise','pendingPaise','reservedPaise'].every(key=>Number.isSafeInteger(value[key])&&value[key]>=0)&&typeof value.redemptionEnabled==='boolean'&&typeof value.frozen==='boolean'&&(!(Object.hasOwn(value,'pendingCashbackPaise')||Object.hasOwn(value,'pendingBonusPoints'))||pendingTrialBreakdown(value)!==null);
 }
 async function load(force=false){
  if(!panels().length||!signedIn){panels().forEach(render);return;}
  if(!force&&cached&&Date.now()-loadedAt<15000){panels().forEach(render);return;}
  if(inflight)return inflight;
  const requestEpoch=epoch;
  const request=(async()=>{try{
   const value=await json(base+'/balance');
   if(!validBalance(value))throw new Error('Invalid wallet');
   if(requestEpoch!==epoch)return;
   cached=value;loadedAt=Date.now();needsLogin=false;
  }catch(error){if(requestEpoch===epoch){if(error.httpStatus===401)invalidateWalletSession();else cached=null;}}
  finally{if(requestEpoch===epoch){inflight=null;panels().forEach(render);}}})();
  inflight=request;panels().forEach(render);return request;
 }
 document.addEventListener('click',async event=>{
  if(!(event.target instanceof Element))return;
  const refresh=event.target.closest('[data-ff-wallet-refresh]');
  if(refresh){event.preventDefault();event.stopImmediatePropagation();if(!busy){await window.ffAccountSession?.refresh();await load(true);}return;}
  const login=event.target.closest('[data-ff-wallet-login]');
  if(login&&window.ffAccountSession?.requestLogin){event.preventDefault();event.stopImmediatePropagation();await window.ffAccountSession.requestLogin(location.pathname+location.search);return;}
  const button=event.target.closest('[data-ff-wallet-apply]');if(!button)return;
  event.preventDefault();event.stopImmediatePropagation();if(busy||button.disabled)return;
  const panel=button.closest('[data-ff-wallet-panel]'),text=copy(panel),actionEpoch=epoch;
  const scope=panel.closest('#halo-cart-sidebar,.halo-dropdown-cart,cart-items')||document;
  const unchecked=[...scope.querySelectorAll('input[name="conditions"]')].some(input=>input.getClientRects().length&&!input.checked);
  if(unchecked){status(panel,text.terms);return;}
  busy=true;panels().forEach(render);status(panel,text.verifying);
  let failure=null;
  try{
   await load(true);
   if(needsLogin){await window.ffAccountSession?.refresh();await window.ffAccountSession?.requestLogin(location.pathname+location.search);return;}
   if(actionEpoch!==epoch)return;
   if(!cached)throw new Error('Unable to verify');
   if(cached.frozen||!cached.redemptionEnabled||cached.availablePaise<1||cached.reservedPaise){window.location.assign(base);return;}
   const latest=normalizeWalletCart(await json((window.Shopify?.routes?.root||'/')+'cart.js'));
   if(actionEpoch!==epoch)return;
   const saved=sessionStorage.getItem(storageKey);if(saved){window.location.assign(base);return;}
   const request={idempotencyKey:crypto.randomUUID(),lines:latest.lines,walletRequestedPaise:cached.availablePaise};
   const query=new URLSearchParams({request:JSON.stringify(request)});if(query.toString().length>7000)throw new Error('Cart too large');
   const auth=await json(base+'/checkout-token?'+query);if(typeof auth.token!=='string'||auth.token.length>2048)throw new Error('Invalid authorization');
   if(actionEpoch!==epoch)return;
   const serialized=JSON.stringify(request);sessionStorage.setItem(storageKey,serialized);if(sessionStorage.getItem(storageKey)!==serialized)throw new Error('Storage unavailable');
   const result=await json(base+'/checkout',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({request,authorization:auth.token})});
   if(actionEpoch!==epoch)return;
   if(result.status==='ready'){
    const invoice=verifiedInvoiceUrl(result.invoiceUrl,panel.dataset.ffWalletShop);if(!invoice)throw new Error('Invalid invoice');window.location.assign(invoice);return;
   }
   if(result.status==='released'||result.status==='settled')sessionStorage.removeItem(storageKey);
   window.location.assign(base);
  }catch(error){failure=text.error;if(error.httpStatus===401){invalidateWalletSession();await window.ffAccountSession?.refresh();await window.ffAccountSession?.requestLogin(location.pathname+location.search);}}
  finally{busy=false;panels().forEach(render);if(failure&&actionEpoch===epoch)status(panel,failure);}
 },true);
 const seen=new WeakSet();let scheduled=false;
 function scan(){scheduled=false;let added=false;for(const panel of panels())if(!seen.has(panel)){seen.add(panel);render(panel);added=true;}if(added)load();}
 const panelSelector='[data-ff-wallet-panel]';
 const observer=new MutationObserver(records=>{
  if(scheduled)return;
  const addedPanel=records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches(panelSelector)||node.querySelector(panelSelector))));
  if(addedPanel){scheduled=true;requestAnimationFrame(scan);}
 });
 const targets=document.querySelectorAll('#halo-cart-sidebar,.halo-dropdown-cart,cart-items,[data-ff-account-hub]');targets.forEach(target=>observer.observe(target,{childList:true,subtree:true}));
 window.addEventListener('ff:account-session',event=>{
  epoch+=1;signedIn=event.detail?.signedIn===true;cached=null;loadedAt=0;inflight=null;needsLogin=false;
  panels().forEach(render);if(signedIn)void load(true);
 });
 document.addEventListener('cart:updated',()=>{scan();void load(true);});
 document.addEventListener('shopify:section:load',scan);
 window.addEventListener('pageshow',event=>{if(event.persisted){void window.ffAccountSession?.refresh();void load(true);}});
 document.addEventListener('visibilitychange',()=>{if(!document.hidden&&Date.now()-loadedAt>30000){void window.ffAccountSession?.refresh();void load(true);}});
 scan();if(!signedIn)void window.ffAccountSession?.refresh();
})();
